<template>
  <div class="user-detail-page fade-in">

    <!-- ===== Top Section: Profile + Summary ===== -->
    <div class="user-header">
      <div class="profile-info">
        <img :src="user.avatar" alt="User" class="user-avatar" />
        <div>
          <h2>{{ user.name }}</h2>
          <p>{{ user.email }}</p>
          <span class="user-status" :class="user.status.toLowerCase()">{{ user.status }}</span>
        </div>
      </div>

      <div class="membership-box">
        <h4>Membership Plan</h4>
        <p class="plan-name">{{ user.plan }}</p>
        <p class="plan-meta">
          Expires: <strong>{{ user.planExpiry }}</strong>
        </p>
        <!-- <button class="btn-primary" @click="updateMembership">
          <i class="bx bx-edit"></i> Update Plan
        </button> -->
      </div>
    </div>

    <!-- ===== KPI Cards ===== -->
    <div class="user-kpi-grid fade-in">
      <div class="kpi-card" v-for="(stat, i) in userStats" :key="i">
        <div>
          <h4>{{ stat.label }}</h4>
          <div class="value">{{ stat.value }}</div>
        </div>
        <i :class="stat.icon + ' kpi-icon'"></i>
      </div>
    </div>

   

    <!-- ===== Tab Content ===== -->
    <transition name="fade-slide" mode="out-in">
      <!-- Overview -->
      <div v-if="activeTab === 'Overview'" key="overview" class="tab-content fade-in">
        <div class="overview-grid">
          <div class="card">
            <h4><i class="bx bx-user"></i> Personal Information</h4>
            <ul class="info-list">
              <li><strong>Email:</strong> {{ user.email }}</li>
              <li><strong>Phone:</strong> {{ user.phone }}</li>
              <li><strong>Joined:</strong> {{ user.joined }}</li>
              <li><strong>Country:</strong> {{ user.country }}</li>
            </ul>
          </div>

          <div class="card">
            <h4><i class="bx bx-line-chart"></i> Activity Overview</h4>
            <ul class="info-list">
              <li><strong>Websites:</strong> {{ userStats[0].value }}</li>
              <li><strong>Bookings:</strong> {{ userStats[1].value }}</li>
              <li><strong>Invoices:</strong> {{ userStats[2].value }}</li>
              <li><strong>Payments:</strong> {{ userStats[3].value }}</li>
            </ul>
          </div>
        </div>
      </div>

   
    </transition>

    <!-- ===== Bottom Actions ===== -->
    <!-- <div class="user-actions">
      <button class="btn-danger" @click="blockUser"><i class="bx bx-block"></i> Block User</button>
      <button class="btn-outline" @click="deleteUser"><i class="bx bx-trash"></i> Delete</button>
      <button class="btn-primary" @click="contactUser"><i class="bx bx-message"></i> Contact</button>
    </div> -->
    <br><br><br><br><br>
  </div>
</template>

<script>
import { apiBaseUrl } from "@/apis/appconst";
export default {
  name: "UserDetail",
  data() {
    return {
      udt:null,
      activeTab: "Overview",
      tabs: [
        "Overview", "Websites", "Invoices", "Estimates", "Credit Memos",
        "Purchase Orders", "Payments", "Activity Logs"
      ],
      user: {
        name: "***** *****",
        email: "info@business.com",
        phone: "+91**********",
        country: "***",
        joined: "** ** ****",
        status: "***",
        plan: "Free",
        planExpiry: "** ** ****",
        avatar: "/images/uplace.jpg",
      },
      userStats: [
        { label: "Websites", value: 0, icon: "bx bx-globe" },
        { label: "Bookings", value: 0, icon: "bx bx-calendar" },
        { label: "Invoices", value: 0, icon: "bx bx-receipt" },
        { label: "Payments", value: "$0", icon: "bx bx-wallet" },
      ],
     
    };
  },
  mounted() {
      const stored = sessionStorage.getItem("udt");
      if (!stored) return;

      const u =  JSON.parse(stored); // single user

      this.user = {
        name: (u.fname || "") + " " + (u.lname || ""),
        email: u.email || "-",
        phone: u.mobile || "-",
        country: u.country || "-",
        joined: u.user_cre_datetime
          ? new Date(u.user_cre_datetime).toLocaleDateString()
          : "-",
        status: u.status == "1" ? "Active" : "Deactive",
        plan: u.user_plan_name || "Free",
        planExpiry: u.user_plan_expiry
          ? new Date(u.user_plan_expiry).toLocaleDateString()
          : "No Expiry",
        avatar: u.avatar
          ? apiBaseUrl + u.avatar
          : "/images/uplace.jpg"
      };

      this.userStats = [
        { label: "Websites", value: u.websites || 0, icon: "bx bx-globe" },
        { label: "Bookings", value: u.bookings || 0, icon: "bx bx-calendar" },
        { label: "Invoices", value: u.invoices || 0, icon: "bx bx-receipt" },
        { label: "Payments", value: u.payments || 0, icon: "bx bx-wallet" }
      ];
    },
};
</script>

<style scoped>
.user-detail-page {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ===== Header Section ===== */
.user-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 20px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.profile-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: 2px solid var(--border);
}

.user-status {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
}
.user-status.active { background: #dcfce7; color: #166534; }
.user-status.deactive { background: #fee2e2; color: #991b1b; }

.membership-box {
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}
.plan-name {
  font-weight: 700;
  font-size: 1.1rem;
  color: var(--text);
}
.plan-meta {
  font-size: 13px;
  color: var(--muted);
}

/* ===== KPI Grid ===== */
.user-kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 16px;
}
.kpi-card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
}
.kpi-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.08);
}

/* ===== Tabs ===== */
.tab-row {
  display: flex;
  gap: 8px;
  border-bottom: 1px solid var(--border);
}
.tab-row button {
  background: none;
  border: none;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  color: var(--muted);
  cursor: pointer;
  transition: all 0.3s ease;
}
.tab-row button.active {
  color: var(--primary);
  border-bottom: 2px solid var(--primary);
}

/* ===== Tab Content ===== */
.overview-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
.card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px;
}
.info-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.info-list li {
  padding: 6px 0;
  border-bottom: 1px dashed var(--border);
  font-size: 13px;
}

/* ===== Websites ===== */
.website-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}
.site-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 14px;
  transition: all 0.3s ease;
}
.site-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.08);
}
.site-card h4 { font-size: 14px; margin-bottom: 4px; }
.site-card p { font-size: 12.5px; color: var(--muted); }

/* ===== Invoices Table ===== */
.invoice-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.invoice-table th, .invoice-table td {
  padding: 10px;
  border-bottom: 1px solid var(--border);
}
.invoice-table th {
  color: var(--muted);
  text-align: left;
}
.badge.paid { background: #dcfce7; color: #166534; }
.badge.pending { background: #fef3c7; color: #92400e; }

/* ===== Activity Logs ===== */
.activity-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.activity-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px dashed var(--border);
}
.activity-list i {
  font-size: 1rem;
  color: var(--primary);
}

/* ===== Bottom Actions ===== */
.user-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}
.btn-danger {
  background: #fee2e2;
  color: #991b1b;
  border: none;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.25s ease;
}
.btn-outline {
  background: #fff;
  border: 1px solid var(--border);
  color: var(--text);
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
}
.btn-danger:hover { background: #fecaca; }
.btn-outline:hover { border-color: var(--primary); color: var(--primary); }

.fade-slide-enter-active, .fade-slide-leave-active {
  transition: all 0.25s ease;
}
.fade-slide-enter-from, .fade-slide-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* ===== Responsive ===== */
@media (max-width: 1024px) {
  .overview-grid { grid-template-columns: 1fr !important; }
  .user-header { flex-direction: column; align-items: flex-start; }
  .membership-box { align-items: flex-start; text-align: left; }
}
@media (max-width: 768px) {
  .user-kpi-grid { grid-template-columns: 1fr 1fr !important; }
}
@media (max-width: 480px) {
  .user-kpi-grid { grid-template-columns: 1fr !important; }
}
@media (max-width: 768px) {
  .tab-row {
    overflow-x: auto;
    white-space: nowrap;
    padding-bottom: 6px;
  }
}

</style>